import { computeInsertTimestamp } from "./journey-insert-position";

/**
 * Timestamp for a touchpoint inserted from the approval drawer — PRD
 * docs/prd/attribution-korrektur.md Story S4/S5, Epic A3/A4/A6, Issue
 * TASK-76. Unlike the journey's free positioning (midpoint between two
 * chosen neighbors), both options here are always "kleinstmöglicher Abstand
 * vor" a single reference event — reuses computeInsertTimestamp's "ganz
 * vorne" branch (no previous neighbor to weigh in).
 *
 *  - "middle": shortly before the event currently being approved.
 *  - "first": shortly before the contact's oldest KNOWN event (across
 *    Postgres and the BigQuery mirror — see the touchpoint-anchor endpoint).
 *    Falls back to the approval event itself when no older event is known
 *    (a brand-new contact / empty history) — "middle" and "first" then
 *    coincide instead of landing on a contradictory value.
 *
 * Pure — deterministic to test, no Date.now().
 */
export type ApprovalTouchpointKind = "middle" | "first";

export function computeApprovalInsertTimestamp(
  kind: ApprovalTouchpointKind,
  approvalAt: string,
  oldestKnownAt: string | null,
): string {
  const referenceAt = kind === "middle" ? approvalAt : (oldestKnownAt ?? approvalAt);
  // Non-null: computeInsertTimestamp(prevAt, nextAt) only returns null when
  // BOTH are null, and referenceAt (nextAt here) is always a real string.
  return computeInsertTimestamp(null, referenceAt)!;
}
